import React from 'react';
import { useNavigate } from 'react-router-dom';

// 画面遷移ボタンの共通実装。遷移先ごとに個別のボタンファイルは作らず、
// 遷移先パス（to）と route state で渡す変数（state）を呼び出し側で明示する。
function NavigateButton({ to, buttonText, state = null, disabled = false, className = 'btn--primary' }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return;
    navigate(to, { state });
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`btn ${disabled ? 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-50' : className}`}
    >
      {buttonText}
    </button>
  );
}

export default NavigateButton;
